var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYaw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.266561,
    height: 45.13869,
    viewBox: "0 0 49 42.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "red"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.96383166,
    strokeMiterlimit: 1,
    d: "M159.71 578.076c7.148 7.034 9.26 12.756 15.204 15.828 17.918 9.26 57.25 17.094 83.62 15.99v-22.6l21.882 20.927 21.88 20.928-21.88 20.926-21.88 20.928v-22.477c-45.034-1.33-62.023-8.897-82.32-17.11-8.017-5.658-13.27-11.877-16.33-17.09l-.177-36.25z",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    color: "#000",
    overflow: "visible",
    "solid-color": "#000000",
    transform: "matrix(.3377 0 0 .337 -53.435 -184.232)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2.96383166px",
    d: "M177.387 586.826l-9.82-11.964 1.606-10c8.536-5.652 19.378-15.605 49.107-16.786l.357 20.893c-21.82.596-33.595 7.56-41.25 17.856z",
    transform: "matrix(.3377 0 0 .337 -53.435 -184.232)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaw);
export default __webpack_public_path__ + "static/media/yaw.7c9da1546bd93fe7feff6e56886c7dc8.svg";
export { ForwardRef as ReactComponent };